<template>
    <v-dialog
        v-model="isOpen"
        :width="width"
        max-width="720"
        scrollable
    >
        <v-card>
            <v-card-title
                class="text-h6"
                :style="{ 'background-color': currentType.headerBgColor }"
            >
                <v-icon
                    :color="currentType.headerIconColor"
                    size="28"
                    class="mb-1 mr-2"
                >
                    {{ currentType.headerIcon }}
                </v-icon>
                {{ title }}
                <v-spacer/>
                <v-btn
                    icon
                    @click.stop="closeModal()"
                >
                    <v-icon>{{ icons.mdiClose }}</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pb-0">
                <slot name="content"></slot>
            </v-card-text>

            <v-card-actions class="py-4">
                <v-spacer/>
                <v-btn
                    plain
                    @click.stop="closeModal()"
                >
                    Bezárás
                </v-btn>
                <slot name="action-btn"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiAlertCircleOutline, mdiCheckCircleOutline, mdiClose } from '@mdi/js';

export default {
    name: 'BnModal',
    props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'default',
        },
        value: {
            type: Boolean,
            required: true,
        },
        width: {
            type: String,
            default: '640',
        }
    },
    data() {
        return {
            icons: {
                mdiClose,
                mdiAlertCircleOutline,
                mdiCheckCircleOutline
            },
            types: {
                default: {
                    headerBgColor: 'transparent',
                    headerIcon: null,
                    headerIconColor: null,
                },
                success: {
                    headerBgColor: 'rgba(0,255,0,0.075)',
                    headerIcon: mdiCheckCircleOutline,
                    headerIconColor: 'green',
                },
                error: {
                    headerBgColor: 'rgba(255,0,0,0.075)',
                    headerIcon: mdiAlertCircleOutline,
                    headerIconColor: 'red',
                },
            }
        };
    },
    methods: {
        closeModal() {
            this.isOpen = false;
        }
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        currentType() {
            return this.types[this.type];
        },
    },
};
</script>
